module.exports = __webpack_public_path__ + "img/900552506.dc7765eb.png";